import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useConfirmUnreadMessagesPresenter } from './ConfirmUnreadMessages.presenter';

export const ConfirmUnreadMessages: FC = observer(() => {
  useConfirmUnreadMessagesPresenter();

  return null;
});
